/**
 * Hujjat qatorlari va holat ohanglari -- sof funksiyalar (test: status.test.ts).
 * Holatning o'zi backend'da hisoblanadi (`services.status_for`); bu yerda faqat ko'rsatish tartibi.
 */
import { OTHER_KIND, type DocumentStatus, type DocumentType, type DriverDocument } from "./types";

export interface DocumentRow {
  key: string;
  kind: string;
  /** Sozlamadagi tur; "boshqa" hujjat uchun null */
  type: DocumentType | null;
  /** Joriy nusxa (backend `is_current`); tur holati shundan */
  doc: DriverDocument | null;
  status: DocumentStatus;
  /** Shu turning boshqa nusxalari (boshqa shtatdagi yoki eskirgan CDL kabi), backend tartibida */
  others: DriverDocument[];
  /** Qator bitta nusxaning o'zi (asosiy qator ostidagi nusxa): so'rash va "yana yuklash" ko'rsatilmaydi */
  copy?: boolean;
}

/** Sozlamadagi turlar tartibida bir qatordan (joriy nusxasi bilan, qolgan nusxalar `others`), so'ngra "boshqa" va sozlamadan chiqarilgan turdagilar */
export function buildRows(types: DocumentType[], documents: DriverDocument[]): DocumentRow[] {
  const rows: DocumentRow[] = types.map((type) => {
    const mine = documents.filter((d) => d.kind === type.key);
    const doc = mine.find((d) => d.is_current) ?? mine[0] ?? null;
    return { key: type.key, kind: type.key, type, doc, status: doc?.status ?? "missing", others: mine.filter((d) => d !== doc) };
  });
  for (const doc of documents) {
    if (doc.kind === OTHER_KIND || !types.some((t) => t.key === doc.kind)) {
      rows.push({ key: `${doc.kind}-${doc.id}`, kind: doc.kind, type: null, doc, status: doc.status, others: [] });
    }
  }
  return rows;
}

/** Asosiy qator ostidagi nusxa qatori: o'sha tur, lekin bitta hujjat */
export function copyRow(row: DocumentRow, doc: DriverDocument): DocumentRow {
  return { key: `${row.kind}-${doc.id}`, kind: row.kind, type: row.type, doc, status: doc.status, others: [], copy: true };
}

export type Tone = "muted" | "warning" | "danger" | "success";

export function statusTone(status: DocumentStatus): Tone {
  switch (status) {
    case "received":
      return "success";
    case "requested":
    case "expiring":
      return "warning";
    case "expired":
      return "danger";
    default:
      return "muted";
  }
}

/** Kun farqi (sana - bugun), mahalliy kun chegarasida */
export function daysUntil(iso: string, today: Date = new Date()): number {
  const [y, m, d] = iso.split("-").map(Number);
  const target = new Date(y, (m ?? 1) - 1, d ?? 1);
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.round((target.getTime() - start.getTime()) / 86_400_000);
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

export type Translate = (key: string, options?: Record<string, unknown>) => string;

/** Tur nomi: o'rnatilgan kalitlar (cdl, medical_card, ...) tarjima qilinadi, sozlamadan qo'shilganlari o'z nomi bilan */
export function kindLabel(t: Translate, kind: string, fallback: string): string {
  return t(`kinds.${kind}`, { defaultValue: fallback });
}
